import { motion } from 'framer-motion';
interface ITransition {
  openVariants?: {
    [key: string]: any;
  };
  transition?: {
    [key: string]: any;
  };
  layout?: boolean | 'position' | 'size';
  initial?: string | {
    [key: string]: any;
  };
  animate?: string | {
    [key: string]: any;
  };
  exit?: string | {
    [key: string]: any;
  };
  onClick?: (event) => void;
  classNames: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}
export default function CustomMotion({
  openVariants,
  transition,
  layout = false,
  initial,
  animate,
  exit,
  onClick,
  classNames,
  style,
  children
}: ITransition) {
  return <motion.div variants={openVariants ?? undefined} transition={transition ?? undefined} layout={layout} initial={initial} animate={animate} exit={exit} onClick={event => onClick?.(event)} className={classNames} style={style ?? undefined} data-sentry-element="unknown" data-sentry-component="CustomMotion" data-sentry-source-file="custom-motion.tsx">
      {children}
    </motion.div>;
}